import { team } from "../assets/base64/team";
import { avatar } from "../assets/base64/avatar";
import { thumnail } from "../assets/base64/thumnail";
import { document } from "../assets/base64/document";
import { videoFiles } from "../assets/base64/videoFiles";

const Resources = {
    IMAGES: {
        TEAM: `data:image/png;base64, ${team}`,
        DOCUMENT: `data:image/png;base64, ${document}`,
        THUMBNAIL: `data:image/png;base64, ${thumnail}`,
        VIDEO_FILES: `data:image/png;base64, ${videoFiles}`,
        AVATAR_THUMBNAIL: `data:image/png;base64, ${avatar}`,
    }
}

export default Resources;